import { CURRENT_CLIENT } from '@/constants'

export type ProductInviteConfig = {
  enabled: boolean
  sidebarWidget: boolean
  headerButton: boolean
  headline: string
  blurb: string
  ctaButtonLabel: string
}

type ProductInviteFeature = {
  enabled?: boolean
  sidebarWidget?: boolean
  headerButton?: boolean
  headline?: string
  blurb?: string
  ctaButtonLabel?: string
}

function clientBrandName(): string {
  return (CURRENT_CLIENT as { name?: string; brand?: string }).brand?.trim()
    || (CURRENT_CLIENT as { name?: string }).name?.trim()
    || 'the product'
}

export function getProductInviteConfig(): ProductInviteConfig | null {
  const raw = (CURRENT_CLIENT as { features?: { productInvite?: ProductInviteFeature } }).features
    ?.productInvite
  if (raw?.enabled !== true) return null
  const brand = clientBrandName()
  return {
    enabled: true,
    sidebarWidget: raw.sidebarWidget !== false,
    headerButton: raw.headerButton === true,
    headline: raw.headline?.trim() || 'Invite a friend',
    blurb: raw.blurb?.trim() || `Share ${brand} with someone who'd find it useful.`,
    ctaButtonLabel: raw.ctaButtonLabel?.trim() || 'Invite',
  }
}

export function isProductInviteEnabled(): boolean {
  return getProductInviteConfig() != null
}

export function shouldShowProductInviteHeaderButton(
  options?: { isAuthenticated?: boolean },
): boolean {
  const config = getProductInviteConfig()
  if (!config?.headerButton) return false
  if (options?.isAuthenticated === false) return false
  return true
}
